/**
 * BrandIcon
 */
import { ForgeIcon } from '../Icons';
import React from 'react';
const BrandIcon = ({ style, ...rest }) => (React.createElement(ForgeIcon, Object.assign({ style: { color: '#f27941', ...style }, titleAccess: "Forge Logo" }, rest)));
export default BrandIcon;
//# sourceMappingURL=BrandIcon.js.map